import { message } from 'antd';

export const success = (cb) => {
  message.loading('フォームより送信中です。', 2.5)
    .then(() => message.success(' 正常に送信されました。', 2.5))
    .then(cb)
};